import type { HTMLInputTypeAttribute } from 'react';
import type { FieldErrors, FieldValues, Path, UseFormRegister } from 'react-hook-form';
interface InputProps {
  label?: string;
  name: Path<FieldValues>;
  placeholder?: string;
  type?: HTMLInputTypeAttribute;
  register: UseFormRegister<FieldValues>;
  classInput?: string;
  classLabel?: string;
  classError?: string;
  errors?: FieldErrors<FieldValues>;
}
const InputText = ({
  register,
  label,
  name,
  required,
  errors,
  type = 'text',
  classInput = `mt-1.5 w-full bg-white rounded-md md:font-normal font-medium border border-[#e3e5e5] placeholder:text-[#A4A5A8] focus:border-2 ${errors?.[name] ? 'focus:border-red-800/70' : 'focus:border-blue-500'} px-3 py-2 md:px-4 md:py-2.5 outline-none`,
  classLabel = 'font-medium text-sm text-gray-700',
  placeholder,
  ...props
}: InputProps & any) => {
  return <>
      <label className={classLabel}>
        {label}
        {required && <span className="text-[#D95341]">*</span>}
      </label>
      <input {...register(name, {
      required,
      ...props
    })} type={type} className={classInput} placeholder={placeholder} />
      {errors?.[name] && <span className="pl-1 pt-1 text-sm text-red-800/80">
          {'*'}
          {errors?.[name]?.message}
        </span>}
    </>;
};
export default InputText;